import { SyntheticEvent } from 'react';
import { isNativePlatformAndroid, isNativePlatformIOS } from '../../../helper/Platform';
import { nativeLogoutAndoid } from './native-logout-android';
import { nativeLogoutIos } from './native-logout-ios';

export function nativeLogout(event: SyntheticEvent<HTMLDivElement>) {
	event.preventDefault();
	if (isNativePlatformIOS()) {
		return nativeLogoutIos();
	}
	if (isNativePlatformAndroid()) {
		return nativeLogoutAndoid();
	}
}
